import {Text, View} from '@react-pdf/renderer'
import {styles} from './Styles'

const TimeStamp = (timeStamp) => (
  <View style={styles.timeStampContainer} fixed>
    <Text style={styles.textRegular}>{timeStamp}</Text>
  </View>
)
export default TimeStamp
